/* src/app/dynamic-forms/form-view/form-view-text2/form-view-text2.component.scss */
.mat-mdc-form-field {
  height: 100%;
}
.customtextarea {
  height: 100%;
  width: 100%;
  position: relative;
}
/*# sourceMappingURL=form-view-text2.component.css.map */
